export const UPDATE_CART = "UPDATE_CART";
export const RESET_TOTAL_CART = "RESET_TOTAL_CART";
